export default __webpack_public_path__ + "static/media/ereader.08c2ba2a.png";